import { Edit, Create } from 'react-admin';
import { EmailList as EmailListComponent } from './EmailList';
import EmailForm from './EmailForm';

//Note: it's a bit redundant to do this instead of direct importing into App.js, but we may want to add additional logic and UI later
export const EmailList = EmailListComponent;
export const EmailEdit = props => ( <Edit {...props}><EmailForm {...props}/></Edit> )
export const EmailCreate = props => ( <Create {...props}><EmailForm {...props}/></Create> )